import { useBgFormContext } from "@app/guranteeFormWrapper";
import { useBGPurchaseShortCuts } from "@app/hooks/useBGPurchaseShortCuts";
import { usePurchaseSearch } from "@app/hooks/usePurchaseSearch";
import { setShowPurchaseFields } from "@app/store/purchaseSlice";
import { VerticalSpace } from "@app/UI/VerticalSpace";
import { Button } from "@farzoom/common-ui-components";
import { BgFormInput } from "@utils/guaranteeForm/formShema";
import { Form, Input, Typography } from "antd";
import { BaseSyntheticEvent, useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useDispatch } from "react-redux";
import { LotsSelectModal } from "./lotsSelectModal";
import { PURCHASE_MAP_ERROR_TYPE } from "@utils/purchaseErrors";
import Overlay from "@app/UI/Overlay";

const { Text } = Typography;

export const PurchaseSearch = () => {
  const {
    control,
    formState: { errors },
    getValues,
  } = useFormContext<BgFormInput>();

  const dispatch = useDispatch();

  const { formDisabled, prefix, canEditPurchase } = useBgFormContext();
  const currentPrefix = (prefix ? `${prefix}.purchase` : "purchase") as "purchase";

  const [purchaseNumberValue, setPurchaseNumberValue] = useState(
    getValues(`${currentPrefix}.purchaseNumber`) || ""
  );

  const {
    tempPurchase,
    canSelectLot,
    onPurchaseNumberChange,
    onCompleteSelectLots,
    onCloseSelectLots,
    purchaseSearchErr,
    handleManualInput,
    isSearch,
  } = usePurchaseSearch({ currentPrefix });

  useBGPurchaseShortCuts();

  const handlePurchaseNumber = (e: BaseSyntheticEvent) => {
    const value = e.target.value.replace(/\s+/g, "");
    setPurchaseNumberValue(value);
    onPurchaseNumberChange(value);
  };

  useEffect(() => {
    return () => {
      dispatch(setShowPurchaseFields(false));
    };
  }, []);

  return (
    <>
      {isSearch && <Overlay />}
      <Controller
        control={control}
        name={`${currentPrefix}.purchaseNumber`}
        rules={{
          required: "Поле обязательно к заполнению",
        }}
        render={({ fieldState: { invalid } }) => (
          <Form.Item
            label="Реестровый № торгов"
            validateStatus={invalid ? "error" : undefined}
            required
            help={errors.purchase?.purchaseNumber?.message}
          >
            <Input
              size="large"
              placeholder="Введите № торгов"
              disabled={formDisabled || !canEditPurchase}
              onChange={handlePurchaseNumber}
              value={purchaseNumberValue}
            />
            {purchaseSearchErr && (
              <VerticalSpace size={0}>
                <Text strong style={{ paddingLeft: "6px" }}>
                  Закупка не найдена.
                </Text>
                <Button type="small" text="Заполните вручную" onClick={handleManualInput} />
              </VerticalSpace>
            )}
          </Form.Item>
        )}
      />
      {canSelectLot && (
        <LotsSelectModal
          purchase={tempPurchase}
          onOk={onCompleteSelectLots}
          onClose={onCloseSelectLots}
        />
      )}
      {errors && errors[PURCHASE_MAP_ERROR_TYPE.purchaseMapError] && (
        <Text type="danger">{errors[PURCHASE_MAP_ERROR_TYPE.purchaseMapError].message}</Text>
      )}
    </>
  );
};
